import { Link } from 'react-router-dom';

interface EmptyStateProps {
  title?: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  secondaryLabel?: string;
  secondaryTo?: string;
}

export default function EmptyState({
  title = '未找到相关影视作品',
  description = '换个关键词或调整筛选条件试试，我们还有很多精彩内容等你发现。',
  actionLabel = '重置筛选',
  onAction,
  secondaryLabel,
  secondaryTo,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100/60 px-6 py-16 text-center">
      <span className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-secondary-100 text-2xl text-secondary-600">
        <i className="ri-film-line" />
      </span>
      <h3 className="font-heading text-lg font-semibold text-foreground-900">{title}</h3>
      <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-500">{description}</p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        {onAction && (
          <button
            type="button"
            onClick={onAction}
            className="cursor-pointer whitespace-nowrap rounded-md bg-primary-600 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
          >
            {actionLabel}
          </button>
        )}
        {secondaryLabel && secondaryTo && (
          <Link
            to={secondaryTo}
            className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            {secondaryLabel}
          </Link>
        )}
      </div>
    </div>
  );
}